import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Container,
  Paper,
  Tabs,
  Tab,
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material'

import { RootState } from '../app/store'
import UpdateProfileForm from '../features/users/components/UpdateProfileForm'
import ChangePasswordForm from '../features/users/components/ChangePasswordForm'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  )
}

const ProfilePage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0)
  const { user } = useSelector((state: RootState) => state.auth)

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  if (!user) {
    return (
      <Container maxWidth="md">
        <Typography variant="h6" color="error" sx={{ pt: 4 }}>
          Please log in to access your profile
        </Typography>
      </Container>
    )
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 3 }}>
        {/* User Info Card */}
        <Card sx={{ mb: 3, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <CardContent>
            <Typography
              variant="h4"
              sx={{ color: 'white', fontWeight: 600, mb: 1 }}
            >
              {user.first_name} {user.last_name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              {user.email}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255, 255, 255, 0.8)', mt: 1 }}
            >
              Role: <strong>{user.role}</strong>
            </Typography>
            {user.company_department && (
              <Typography
                variant="body2"
                sx={{ color: 'rgba(255, 255, 255, 0.8)' }}
              >
                Department: <strong>{user.company_department.department_name}</strong>
              </Typography>
            )}
          </CardContent>
        </Card>

        {/* Profile Settings Tabs */}
        <Paper sx={{ mb: 2 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="profile tabs"
            sx={{
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <Tab label="Edit Profile" id="profile-tab-0" aria-controls="profile-tabpanel-0" />
            <Tab label="Change Password" id="profile-tab-1" aria-controls="profile-tabpanel-1" />
          </Tabs>

          <Box sx={{ p: 3 }}>
            <TabPanel value={tabValue} index={0}>
              <UpdateProfileForm />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <ChangePasswordForm />
            </TabPanel>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}

export default ProfilePage
